import { FormattedMessage } from 'react-intl';
import GlassCard from '@/app/components/GlassCard';
import PublicLayout from '@/app/layouts/PublicLayout';

export default function TermsPage() {
  return (
    <PublicLayout>
      <GlassCard>
        <div className="space-y-8 text-slate-700">
          <header className="space-y-2">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-400">
              <FormattedMessage id="legal.terms.kicker" />
            </p>
            <h1 className="text-3xl font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.title" />
            </h1>
            <p className="text-sm text-slate-500">
              <FormattedMessage id="legal.terms.effectiveDate" />
            </p>
          </header>

          <p className="text-sm text-slate-600">
            <FormattedMessage id="legal.terms.intro" />
          </p>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section1.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section1.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section2.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section2.body" />
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section3.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section3.body" />
            </p>
            <ul className="list-disc space-y-2 pl-5 text-sm text-slate-600">
              <li><FormattedMessage id="legal.terms.section3.item1" /></li>
              <li><FormattedMessage id="legal.terms.section3.item2" /></li>
              <li><FormattedMessage id="legal.terms.section3.item3" /></li>
              <li><FormattedMessage id="legal.terms.section3.item4" /></li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section4.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section4.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section5.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section5.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section6.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section6.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section7.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section7.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section8.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section8.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section9.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section9.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section10.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section10.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section11.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section11.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section12.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section12.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section13.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section13.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.terms.section14.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.terms.section14.body" />
            </p>
          </section>
        </div>
      </GlassCard>
    </PublicLayout>
  );
}
